import { MessagingHelper } from "../helpers/MessagingHelper";
import { PaginatedList } from "../helpers/PaginatedList";
import { Parameter } from "../models/Parameter";
import { PipeDTO } from "../models/Pipe/PipeDTO";
import { CreateNextPossibleStatusDTO } from "../models/Status/CreateNextPossibleStatusDTO";
import { GetPossibleStatusByBaseStatus } from "../models/Status/GetPossibleStatusByBaseStatusDTO";
import { GetStatusWithNameDTO } from "../models/Status/GetStatusWithNameDTO";
import { GetStatusWithPipeDTO } from "../models/Status/GetStatusWithPipeDTO";
import { NextPossibleStatusDTO } from "../models/Status/NextPossibleStatusDTO";
import { RoleStatusPermissionsDTO } from "../models/Status/RoleStatusPermissionsDTO";
import { RolePossibleStatusPermissionDTO } from "../models/Status/RolePossibleStatusPermissionDTO";
import { StatusUsersDTO } from "../models/Status/StatusUsersDTO";
import { RoleDTO } from "../models/User/RoleDTO";
import { APIService } from "./APIService";
import { CreateNewStatusDTO } from "../models/Status/CreateNewStatusDTO";
import { SearchRoleDTO } from "../models/User/SearchRoleDTO";
import { StatusUpdateDTO } from "../models/Status/StatusUpdateDTO";


export class StatusService {

    async GetAllNextPossibleStatus(   
        searchParameters: Parameter[],
        sortingParameters: Parameter[],
        currentPage: number,
        pageSize: number,
    ) : Promise<PaginatedList<NextPossibleStatusDTO>> {

        try{
        const response = await APIService.Axios().post(
            `${APIService.GetURL()}/Status/AllRelatedStatus`,
                {
                    searchParameters,
                    sortingParameters,
                    currentPage,
                    pageSize,
                }, 
                {
                    headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
        );
            return response.data;

        }catch (error){
            return new PaginatedList<NextPossibleStatusDTO>(
                false,
                "Erro ao obter estados",
                "",
                [],
                0,
            );
        }
    }

    async GetPossibleStatusById( firstId: number, secondId: number ) : Promise<MessagingHelper<NextPossibleStatusDTO | null>>{
        try{
            const response = await APIService.Axios().get(
                `${APIService.GetURL()}/Status/RelatedStatus`,
                {
                    params: {
                        firstId,
                        secondId,
                    },
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                        },
                },
            );
            return response.data;

        } catch(error){
            return new MessagingHelper<null>(
                false,
                "Erro ao obter a relação entre estados.",
                null
            );
        }
    }

    async CreateStatusRelation( createNextStatus: CreateNextPossibleStatusDTO ) : Promise<MessagingHelper<string>>{
        try{

            const response = await APIService.Axios().post(
                `${APIService.GetURL()}/Status/CreateStatusRelation`,
                {
                    ...createNextStatus
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                        },
                },
            );

            return response.data;

        }catch(error){
            return new MessagingHelper<string>(false, "Erro ao ligar ao servidor para criar relação entre estados", "");
        }
    }

    async GetAllAssistanceStatus(
        searchParameters: Parameter[],
        sortingParameters: Parameter[],
        currentPage: number,
        pageSize: number,
    ) : Promise<PaginatedList<GetStatusWithNameDTO>>{
        try{
            const response = await APIService.Axios().post(
                `${APIService.GetURL()}/Status/AllAssistanceStatus`,
                    {
                        searchParameters,
                        sortingParameters,
                        currentPage,
                        pageSize,
                    },
                    {
                        headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                        },
                    }
            );
                return response.data;
    
        }catch (error){
            return new PaginatedList<GetStatusWithNameDTO>(
                false,
                "Erro ao obter estados",
                "",
                [],
                0,
            );
        }
    }

    async GetStatus(name: string) : Promise<MessagingHelper<GetStatusWithNameDTO | null>>{
        try{
            const response = await APIService.Axios().get(
                `${APIService.GetURL()}/Status/StatusByName`,
                {
                    params: {name},
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                        },
                },
            );
            return response.data;

        } catch(error){
            return new MessagingHelper<null>(
                false,
                "Erro ao obter estado.",
                null
            );
        }
    }

    async GetAllStatusPaginated(
        searchParameters: Parameter[],
        sortingParameters: Parameter[],
        currentPage: number,
        pageSize: number,
    ) : Promise<PaginatedList<GetStatusWithPipeDTO>>{
        try{
            const response = await APIService.Axios().post(
                `${APIService.GetURL()}/Status/AllStatusPaginated`,
                    {
                        searchParameters,
                        sortingParameters,
                        currentPage,
                        pageSize,
                    },
                    {
                        headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                        },
                    }
            );
                return response.data;
    
        }catch (error){
            return new PaginatedList<GetStatusWithPipeDTO>(
                false,
                "Erro ao obter estados",
                "",
                [],
                0,
            );
        }
    }

    async GetAllPipes() : Promise<MessagingHelper<PipeDTO[] | null>>{
        try{
            const response = await APIService.Axios().get(
                `${APIService.GetURL()}/Status/AllPipes`,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                        },
                },
            );
            return response.data;

        } catch(error){
            return new MessagingHelper<null>(
                false,
                "Erro ao ligar ao servidor para obter processos.",
                null
            );
        }
    }

    async GetPipeByName(name: string) : Promise<MessagingHelper<PipeDTO | null>>{
        try{
            const response = await APIService.Axios().get(
                `${APIService.GetURL()}/Status/PipeByName`,
                {
                    params: {name},
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                        },
                }
            )
            return response.data;

        } catch(error){
            return new MessagingHelper<null>(
                false,
                "Erro ao obter estado.",
                null
            );
        }
    }

    async GetStatusById(id: string) : Promise<MessagingHelper<GetStatusWithPipeDTO | null>>{
        try{
            const response = await APIService.Axios().get(
                `${APIService.GetURL()}/Status/StatusById`,
                {
                    params: {id},
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                        },
                }
            )
            return response.data;

        } catch(error){
            return new MessagingHelper<null>(
                false,
                "Erro ao ligar ao servidor para obter estado.",
                null
            );
        }
    }

    async GetPossibleStatusByBaseStatus(
       search: GetPossibleStatusByBaseStatus
    ) : Promise<PaginatedList<NextPossibleStatusDTO>>{

        try{
            const response = await APIService.Axios().post(
                `${APIService.GetURL()}/Status/PossibleStatusByBaseStatus`,
                    {   currentPage: search.currentPage,
                        pageSize: search.pageSize
                    },
                    {
                        params: {id: search.id},
                        headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                        },
                    }
            );
                return response.data;
    
        }catch (error){
            return new PaginatedList<NextPossibleStatusDTO>(
                false,
                "Erro ao ligar ao servidor para obter estados relacionados.",
                "",
                [],
                0,
            );
        }
    }

    async GetPermissionToNavigateStatus(search: GetPossibleStatusByBaseStatus) : Promise<PaginatedList<RoleStatusPermissionsDTO>>{
        try{
            const response = await APIService.Axios().post(
                `${APIService.GetURL()}/Status/PermissionToNavigateStatus`,
                    {   currentPage: search.currentPage,
                        pageSize: search.pageSize
                    },
                    {
                        params: {id: search.id},
                        headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                        },
                    }
            );
                
                return response.data;

        } catch(error){
            return new PaginatedList<RoleStatusPermissionsDTO>(
                false,
                "Erro ao ligar ao servidor para obter permissões para navegar estado.",
                "",
                [],
                0,
            );
        }
    }

    async GetPermissionToEditStatus(search: GetPossibleStatusByBaseStatus) : Promise<PaginatedList<RolePossibleStatusPermissionDTO>>{
        try{
            const response = await APIService.Axios().post(
                `${APIService.GetURL()}/Status/PermissionToEditStatus`,
                    {   currentPage: search.currentPage,
                        pageSize: search.pageSize
                    },
                    {
                        params: {id: search.id},
                        headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                        },
                    }
            );
                
                return response.data;
    
        }catch (error){
            return new PaginatedList<RolePossibleStatusPermissionDTO>(
                false,
                "Erro ao ligar ao servidor para obter permissões para editar estado.",
                "",
                [],
                0,
            );
        }
    }

    async StatusRoleById(id: string) : Promise<MessagingHelper<RoleDTO | null>>{
        try{
            const response = await APIService.Axios().get(
                `${APIService.GetURL()}/Status/StatusRoleById`,
                {
                    params: {id},
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                        },
                }
            )
            return response.data;

        } catch(error){
            return new MessagingHelper<null>(
                false,
                "Erro ao ligar ao servidor para obter perfil.",
                null
            );
        }
    }

    async GetRoleUsers(
        search: GetPossibleStatusByBaseStatus
    ) : Promise<PaginatedList<StatusUsersDTO>>{
        try{
            const response = await APIService.Axios().post(
                `${APIService.GetURL()}/Status/RoleUsers`,
                    {   currentPage: search.currentPage,
                        pageSize: search.pageSize
                    },
                    {
                        params: {id: search.id},
                        headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                        },
                    }
            );
                
                return response.data;
    
        }catch (error){
            return new PaginatedList<StatusUsersDTO>(
                false,
                "Erro ao ligar ao servidor para obter utilizadores.",
                "",
                [],
                0,
            );
        }
    }

    async EditStatus(statusUpdate: StatusUpdateDTO): Promise<MessagingHelper<null>> {
        try {
            var response = await APIService.Axios().patch(
                `${APIService.GetURL()}/Status/UpdateStatus/${statusUpdate.id}`,
                { ...statusUpdate },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao ligar ao servidor para atualizar o estado",
                null,
            );
        }
    }   

    async GetAllStatus() : Promise<MessagingHelper<GetStatusWithNameDTO[] | null>>{
        try{
            const response = await APIService.Axios().get(
                `${APIService.GetURL()}/Status/AllStatus`,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                        },
                },
            );
            return response.data;

        } catch(error){
            return new MessagingHelper<null>(
                false,
                "Erro ao ligar ao servidor para obter processos.",
                null
            );
        }
    }

    async CreateStatus(status: CreateNewStatusDTO) : Promise<MessagingHelper<string>>{
        try{

            const response = await APIService.Axios().post(
                `${APIService.GetURL()}/Status/CreateStatus`,
                {
                    ...status
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                        },
                },
            );

            return response.data;

        }catch(error){
            return new MessagingHelper<string>(false, "Erro ao ligar ao servidor para criar estado", "");
        }
    }

    async CreateStatusPermission(data: RoleStatusPermissionsDTO) : Promise<MessagingHelper<string>>{
        try{

            const response = await APIService.Axios().post(
                `${APIService.GetURL()}/Status/CreateNavegationStatusPermission`,
                {
                    ...data
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                        },
                },
            );

            return response.data;

        } catch(error) {
            return new MessagingHelper<string>(false, "Erro ao ligar ao servidor para criar permissão de navegação no estado.", "");
        }
    }

    async CreatePossibleStatusPermission(data: RolePossibleStatusPermissionDTO) : Promise<MessagingHelper<string>>{
        try{

            const response = await APIService.Axios().post(
                `${APIService.GetURL()}/Status/CreateEditStatusPermission`,
                {
                    ...data
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                        },
                },
            );

            return response.data;

        } catch(error) {
            return new MessagingHelper<string>(false, "Erro ao ligar ao servidor para criar permissão de edição do estado base para outro.", "");
        }
    }

    async GetAllRoles() : Promise<MessagingHelper<RoleDTO[] | null>>{
        try{

            const response = await APIService.Axios().get(
                `${APIService.GetURL()}/Status/AllRoles`,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                        },
                },
            );

            return response.data;

        } catch(error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao ligar ao servidor para obter perfis.",
                null
            );
        }
    }

    async GetRoleByName(data: SearchRoleDTO) : Promise<MessagingHelper<RoleDTO | null>>{
        try{

            const response = await APIService.Axios().post(
                `${APIService.GetURL()}/Status/RoleByName`,
                {
                    ...data
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                        },
                },
            );

            return response.data;

        } catch(error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao ligar ao servidor para obter perfil pelo nome.",
                null
            );
        }
    }

    async DeletePermissionFromStatusId(nextPossibleStatusId: number, roleId: string) {
        try {
            const response = await APIService.Axios().delete(
            `${APIService.GetURL()}/Status/DeletePermissionFromStatusId`,
            {
                params: {
                nextPossibleStatusId,
                roleId
                },
                headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "Bearer " + APIService.GetToken(),
                },
            }
            );

            return response.data;
        } catch (error) {
            return new MessagingHelper(
            false,
            "Erro ao eliminar a permissão do estado.",
            ""
            );
        }
    }

    async DeletePermissionEditStatus(statusId: number, roleId: string) {
        try {
            const response = await APIService.Axios().delete(
            `${APIService.GetURL()}/Status/DeletePermissionEditStatus`,
            {
                params: { statusId, roleId },
                
                headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "Bearer " + APIService.GetToken(),
                },
            }
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper(false, "Erro ao ligar ao servidor para eliminar perfil do estado .", "");
        }
    }

    async DeleteNextPossibleStatus(firstId: number, secondId: number) : Promise<MessagingHelper<string>> {
        try {
            const response = await APIService.Axios().delete(
                `${APIService.GetURL()}/Status/DeleteNextPossibleStatus`,
                {
                    params: { firstId, secondId },
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<string>(false, "Erro ao ligar ao servidor para eliminar relação entre estados.", "");
        }
    }

    async GetStatusByPipeId(pipeId: string) : Promise<MessagingHelper<GetStatusWithPipeDTO[] | null>>{
        try{
            const response = await APIService.Axios().get(
                `${APIService.GetURL()}/Status/StatusByPipeId`,
                {
                    params: {pipeId},
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                        },
                }
            )
            return response.data;

        } catch(error){
            return new MessagingHelper<null>(
                false,
                "Erro ao ligar ao servidor para obter estados por pipe.",
                null
            );
        }
    }
}